import { getUserTool } from './get_user.js';
import { listUsersTool } from './list_users.js';

export const userTools = [listUsersTool, getUserTool];
